import { Component, OnInit, ViewChild, TemplateRef, inject } from '@angular/core';
import { DatatableColumn } from 'projects/bis-shared/src/lib/datatable/datatable-column';
import { DatatableColumnWidth } from 'projects/bis-shared/src/lib/datatable/datatable-column-width';
import { DatatableComponent } from 'projects/bis-shared/src/lib/datatable/datatable/datatable.component';
import { DatatableSort } from 'projects/bis-shared/src/lib/datatable/datatable-sort';
import { DatatableStaticTemplateType } from 'projects/bis-shared/src/lib/datatable/datatable-static-template';
import { AppUrls } from 'projects/bis-shared/src/lib/utility/appurls';
import { IdentityService } from 'projects/bis-shared/src/lib/auth/identity.service';
import * as moment from 'moment-timezone';
import { ExternalApiUrls } from 'projects/bis-shared/src/lib/utility/apiurls-external';
import { ObjectTypeCode } from 'projects/bis-shared/src/lib/utility/system-type-constants';
import { Moment } from 'moment-timezone';
import { FilterDataType } from 'projects/bis-shared/src/lib/datatable/datatable-filter/filter-operations';
import { DatatableModule } from 'projects/bis-shared/src/lib/datatable/datatable.module';
import { EntityFormatterPipe } from 'projects/bis-shared/src/lib/utility/entity-formatter.pipe';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-active-prior-auth-list-provider-component',
  templateUrl: './active-prior-auth-list-provider.component.html',
  styleUrls: ['./active-prior-auth-list-provider.component.scss'],
  imports: [
    DatatableModule,
    EntityFormatterPipe,
    RouterModule,
  ],
})
export class ActivePriorAuthListProviderComponent implements OnInit {
  private identityService = inject(IdentityService);
  private externalApiUrls = inject(ExternalApiUrls);

  @ViewChild(DatatableComponent) datatableComponent: DatatableComponent;
  @ViewChild('idTemplate', { static: true }) idTemplate: TemplateRef<any>;
  @ViewChild('injuryDateTemplate', { static: true }) injuryDateTemplate: TemplateRef<any>;
  columns: DatatableColumn[];
  dataUrl: string;
  defaultSort: DatatableSort[];
  AppUrls = AppUrls;
  lastLoginDate: Moment = this.identityService.apiToken.lastLoginDateTime;
  priorAuthTypeCode = ObjectTypeCode.PriorAuthorization;

  
 

  constructor() {
    this.defaultSort = [
      {
        property: 'assignedOrderBy',
        sortAscending: true,
      },
      {
        property: 'dueDate',
        sortAscending: true,
      },
    ];
  }

  ngOnInit() {
    this.setColumns();
    this.dataUrl = this.externalApiUrls.priorAuthorization.priorAuthorizationWorkRequest();
  }

  setColumns() {
    this.columns = [
      {
        title: 'PAR ID',
        property: 'priorAuthorizationId',
        filterDataType: FilterDataType.SystemId,
        filterSystemIdFixedTypeCode: ObjectTypeCode.PriorAuthorization,
        template: this.idTemplate,
        width: 150,
      },
      {
        title: 'Type',
        property: 'priorAuthorizationRequestType',
        filterDataType: FilterDataType.Reference,
      },
      {
        title: 'Due Date',
        property: 'dueDate',
        filterDataType: FilterDataType.DateTime,
        template: DatatableStaticTemplateType.EasternDateTemplate,
        width: DatatableColumnWidth.medium,
      },
      {
        title: 'Patient',
        property: 'patient',
        filterDataType: FilterDataType.String,
      },
      {
        title: 'DOB',
        property: 'dateOfBirth',
        filterDataType: FilterDataType.Date,
        template: DatatableStaticTemplateType.UtcDateTemplate,
      },
      {
        title: 'Current Activity',
        property: 'workRequestName',
        filterDataType: FilterDataType.String,
      },
      {
        title: 'Injury Date',
        property: 'dateOfInjury',
        filterDataType: FilterDataType.Date,
        width: DatatableColumnWidth.medium,
        template: this.injuryDateTemplate,
      },
      {
        title: 'WCB Case #',
        property: 'wcbCaseNumber',
        filterDataType: FilterDataType.String,
        template: DatatableStaticTemplateType.CaseNumberTemplate,
        width: DatatableColumnWidth.large,
      },
      {
        title: 'Assigned Organization',
        property: 'assignedOrganization',
        filterDataType: FilterDataType.String,
      },
      { title: 'Assigned User', property: 'assignedUser', filterDataType: FilterDataType.String },
      {
        title: 'Claim Admin Claim #',
        property: 'carrierCaseNumber',
        filterDataType: FilterDataType.String,
      },
      { title: 'Claim Admin', property: 'claimAdminName', filterDataType: FilterDataType.String },
      { title: 'Insurer', property: 'insurerName', filterDataType: FilterDataType.String },
      { title: 'Provider', property: 'provider', filterDataType: FilterDataType.String },
      {
        title: 'PAR Status',
        property: 'priorAuthStatus',
        filterDataType: FilterDataType.Reference,
      },
      {
        title: 'PAR Status Date',
        property: 'priorAuthStatusDate',
        filterDataType: FilterDataType.Date,
        template: DatatableStaticTemplateType.EasternDateTimeHMSTemplate,
      },
    ];
  }

  getRowClass = (row: any) => {
    if (
      moment(row.workRequestUpdateDate).isAfter(this.lastLoginDate) ||
      moment(row.latestRFIStateDT).isAfter(this.lastLoginDate)
    ) {
      return 'row-highlight';
    } else {
      return '';
    }
  };
}
